<template>
  <section class="contact-header">
    <div class="header-background"></div>
    <div class="container">
      <div class="row">
        <div class="col-lg-10 col-xl-8 mx-auto text-center">
          <div class="header-content">
            <div class="header-icon-wrapper">
              <i class="fas fa-envelope-open-text header-icon"></i>
            </div>
            <h1 class="header-title">Hai bisogno di aiuto?</h1>
            <p class="header-subtitle">
              Siamo qui per rispondere alle tue domande su App Lotteria degli Scontrini. 
              Contattaci per supporto, segnalazioni o qualsiasi altra richiesta.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ContactHeader'
}
</script>

<style scoped>
.contact-header {
  position: relative;
  padding: 180px 0 140px;
  overflow: hidden;
  background: linear-gradient(135deg, #2a5298 0%, #1e3c72 100%);
}

.header-background {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, #2a5298 0%, #1e3c72 100%);
  opacity: 0.95;
}

.header-background::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.05) 0%, transparent 70%);
  animation: pulse 8s ease-in-out infinite;
}

.header-background::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: 
    radial-gradient(circle at 20% 50%, rgba(255, 255, 255, 0.03) 0%, transparent 50%),
    radial-gradient(circle at 80% 80%, rgba(255, 255, 255, 0.03) 0%, transparent 50%);
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
    opacity: 0.5;
  }
  50% {
    transform: scale(1.1);
    opacity: 0.8;
  }
}

.header-content {
  position: relative;
  z-index: 1;
  animation: fadeInUp 0.8s ease-out;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.header-icon-wrapper {
  width: 120px;
  height: 120px;
  margin: 0 auto 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 50%;
  backdrop-filter: blur(10px);
  border: 2px solid rgba(255, 255, 255, 0.25);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
  animation: iconFloat 3s ease-in-out infinite;
}

.header-icon-wrapper:hover {
  transform: scale(1.05);
  background: rgba(255, 255, 255, 0.2);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.3);
}

@keyframes iconFloat {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}

.header-icon {
  font-size: 3.5rem;
  color: #ffffff;
  opacity: 0.95;
}

.header-title {
  font-size: 3.5rem;
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 32px;
  line-height: 1.2;
  letter-spacing: -0.02em;
}

.header-subtitle {
  font-size: 1.25rem;
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.7;
  max-width: 700px;
  margin: 0 auto;
  font-weight: 300;
}

@media (max-width: 768px) {
  .contact-header {
    padding: 140px 0 100px;
  }
  
  .header-icon-wrapper {
    width: 100px;
    height: 100px;
    margin-bottom: 32px;
  }
  
  .header-icon {
    font-size: 2.8rem;
  }
  
  .header-title {
    font-size: 2.5rem;
    margin-bottom: 24px;
  }
  
  .header-subtitle {
    font-size: 1.1rem;
  }
}
</style>

